import thinkingdata from "thinkingdata-browser";
import { getEnvCode } from './env';

// ThinkingData 配置
const thinkingAppID = "26001";
const thinkingAppUrl = "https://tunnel-dga.dodjoy.com";
const config = {
  appId: thinkingAppID,
  serverUrl: thinkingAppUrl,
  showLog: false,
  useAppTrack: true // 打通 APP 与 H5
};

let isThinkingDataInitialized = false;

// 获取环境代码
export const getEnvironmentCode = (): string => {
  return getEnvCode();
};

// 提交追踪数据
export const submitTrack = (eventName: string, data: any, options: any = {}) => {
  try {
    if ("callback" in options && options.callback instanceof Function) {
      options.callback({ eventName, data, options });
    } else {
      // 若未定义回调函数，则默认调用track方法
      thinkingdata.track(eventName, data);
    }
    if (options.debug) {
      console.log(data);
    }
  } catch (error) {
    if (options.debug) {
      console.log(error);
    }
  }
};

// 初始化 ThinkingData
export const initThinkingData = (params: any) => {
  if (isThinkingDataInitialized) {
    // 已初始化，只更新登录状态
    if (params.account) {
      thinkingdata.login(params.account);
    }
    return;
  }

  thinkingdata.init(config);
  if (params.account) {
    thinkingdata.login(params.account);
  }
  const currentId = thinkingdata.getDistinctId();
  thinkingdata.identify(currentId);
  thinkingdata.setDynamicSuperProperties(() => {
    return {
      pageName: params.pageName || document.title,
      environment: getEnvironmentCode()
    };
  });

  isThinkingDataInitialized = true;
};

// 退出登录：清空 account_id，后续事件不再携带 #account_id
// 注意不能重新 init 来达到这个目的：SDK 的 init 有幂等守卫（config 已存在时直接 return），
// 且重建 persistence 会丢掉 distinct_id 与公共属性。logout() 不传参即保留 distinct_id（保住打通 App 与 H5）
export const logoutThinkingData = () => {
  if (!isThinkingDataInitialized) return; // 未初始化时 persistence 还不存在，直接调用会抛错
  try {
    thinkingdata.logout();
  } catch (error) {
    console.warn('thinkingdata logout 失败', error);
  }
};
